import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { APIS } from 'app/common/constants';
import { HttpService } from 'app/core/services/http.service';
import { IReportEmbedConfiguration, models, Report } from 'powerbi-client';
import { PowerBIReportEmbedComponent } from 'powerbi-client-angular';
import {Subject} from "rxjs";
import {takeUntil} from "rxjs/operators";

@Component({
  selector: 'app-powerbi',
  templateUrl: './powerbi.component.html',
  styleUrls: ['./powerbi.component.css']
})
export class PowerbiComponent implements OnInit, OnDestroy {
  @ViewChild('embedContainer') embedContainer: PowerBIReportEmbedComponent;
  config: IReportEmbedConfiguration = {
    type: 'report',
    embedUrl: undefined,
    tokenType: models.TokenType.Embed,
    accessToken: undefined,
    settings: undefined,
  };
  cssClass;
  destroy$ = new Subject();
  refreshTimeout:ReturnType<typeof setTimeout> = null;
  constructor(private route: ActivatedRoute, private httpService: HttpService) { }

  ngOnInit(): void {
    const { reportId, pageName } = this.route.snapshot.data;
    this.cssClass = 'h-100';
    this.fetchAndSetToken(reportId, pageName);
  }

  fetchAndSetToken(reportId: string, pageName: string): void {
    this.httpService.getData(APIS.POWERBI_TOKEN, { report_id: reportId })
      .pipe(takeUntil(this.destroy$))
      .subscribe(
      (res) => {
        this.config = {
          ...this.config,
          id: reportId,
          embedUrl: 'https://app.powerbi.com/reportEmbed',
          accessToken: res.token,
          pageName,
          settings: {
            panes: {
              pageNavigation: {
                visible: false
              }
            }
          }
        };
        const expirationTime = new Date(res.expiration).getTime();
        clearTimeout(this.refreshTimeout);
        this.refreshTimeout = setTimeout(() => {
          this.fetchAndSetToken(reportId, pageName);
        }, Math.max((expirationTime - Date.now()) - 120000,120000));
      },
      (error) => {
        console.error('Failed to fetch Power BI token:', error);
      }
    );
  }

  async exportToPDF() {
    const report = this.embedContainer.getReport() as Report;
    await report.print();
  }

  ngOnDestroy() {
    clearTimeout(this.refreshTimeout);
    this.destroy$.next(null);
    this.destroy$.complete();
  }
}
